// frontend/src/pages/login.js
import React from 'react';
import logo from '../../../../assets/images/logo_agent.png';
import {
    TextInput,
    PasswordInput,
    Checkbox,
    Paper,
    Title,
    Text,
    Container,
    Group,
    Button,
    Image,
} from '@mantine/core';
import useLogin from './useLogin';
import { Helmet } from 'react-helmet';
import SEO from '../../../../components/seo/SEO';

const Login = () => {

    const { form: {
        getInputProps,

    },
        handleLogin,
        loginMutation
    } = useLogin()


    // <Helmet>
    //     <title>FAME.Live Agent</title>
    //     <meta name="description" content="Manage your creators with FAME.Live for Agent" />
    //     {/* Open Graph Meta Tags */}
    //     <meta property="og:title" content="FAME.Live Agent" />
    //     <meta property="og:description" content="Manage your creators with FAME.Live for Agent" />
    //     <meta property="og:image" content={`${window.location.origin}/assets/images/icon_agent.png`} />
    //     <meta property="og:type" content="website" />
    //     <meta property="og:url" content={window.location.href} />
    //     {/* Twitter Card Meta Tags */}
    //     <meta name="twitter:card" content="summary_large_image" />
    //     <meta name="twitter:title" content="FAME.Live Agent" />
    //     <meta name="twitter:description" content="Manage your creators with FAME.Live for Agent" />
    //     <meta name="twitter:image" content={`${window.location.origin}/assets/images/icon_agent.png`} />
    // </Helmet>

    return (
        <>
            <Container size={420} my={40} >
                <SEO

                />
                <Title >
                    <Image src={logo} alt='no-logo-found' size="10px" />
                </Title>
                <Text c="dimmed" size="sm" ta="center" mt={5}>
                    {/* Do not have an account yet?{' '} */}
                    {/* <Anchor size="sm" component="button">
             Create account
           </Anchor> */}
                </Text>

                <Paper withBorder shadow="md" p={30} mt={30} radius="md">
                    <h5> Enter Agent Admin Login Credentials :</h5>
                    <TextInput label="Email" placeholder="Enter your email" required
                        {...getInputProps('email')}

                    />
                    <PasswordInput label="Password" placeholder="Your password" required mt="md"
                        {...getInputProps('password')}

                    />
                    <Group justify="space-between" mt="lg">
                        <Checkbox label="Remember me" />
                        {/* <Anchor component="button" size="sm">
               Forgot password?
             </Anchor> */}
                    </Group>
                    <Button variant="gradient"
                        gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }} fullWidth mt="xl" onClick={handleLogin} loading={loginMutation?.isPending}>
                        Sign in
                    </Button>
                </Paper>
            </Container>
        </>

    );
};

export default Login;
